import { render } from "./MenuDiagnostic.vue?vue&type=template&id=aca57a06"
import script from "./MenuDiagnostic.vue?vue&type=script&lang=js"
export * from "./MenuDiagnostic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__